import {
  DocumentOrganizationKeys,
  FilterDocument,
  GroupByMode,
  ID,
  LinkedItemSection,
  Timestamp,
} from '@griply/types';

// Goals and life areas both own `sections` + `filterDocument`, so this builds
// the section-append update for either entity. The result is structurally an
// `UpdateGoal` / `UpdateLifeArea` (id + the two changed fields).
export type SectionedEntity = {
  id: ID;
  sections: LinkedItemSection[] | null;
  filterDocument?: FilterDocument | null;
};

export type BuildSectionUpdateOptions = {
  id: ID;
  name: string;
  createdAt: Date;
};

export type SectionUpdate = {
  id: ID;
  sections: LinkedItemSection[];
  filterDocument: FilterDocument;
};

export const buildSectionUpdate = (
  entity: SectionedEntity,
  { id, name, createdAt }: BuildSectionUpdateOptions,
): SectionUpdate => {
  const sections = entity.sections ?? [];

  return {
    id: entity.id,
    sections: [
      ...sections,
      { id, name, tasks: [], createdAt: createdAt as unknown as Timestamp },
    ],
    filterDocument: {
      ...(entity.filterDocument ?? {}),
      [DocumentOrganizationKeys.GroupByMode]: GroupByMode.Section,
    },
  };
};
